import { addDateUnit, subtractDateUnit, toServerDate } from 'utils/dates'
import DateFilter from 'utils/filters/dateFilter'

import styles from './FilterPanel.component.module.css'

const DEFAULT_DAYS = 20

export const getDateRangeDefault = () => {
  const now = new Date()
  return {
    startDate: toServerDate(subtractDateUnit(now, DEFAULT_DAYS)),
    endDate: toServerDate(addDateUnit(now, 1)),
  }
}

export const reportingFilters = {
  dateRange: new DateFilter({
    filterKey: 'dateRange',
    label: 'Created',
    dataKey: 'dateRange',
    styles,
    messages: {
      addDate: 'Select a date range',
      addDateFilter: 'Apply',
    },
    defaultState: getDateRangeDefault(),
  }),
}

export const filterSetup = [
  {
    key: 'dateRange',
    title: 'Created Date',
    filters: [reportingFilters.createdDateRange],
  },
]
